import { gql } from '@apollo/client';

// Build the GraphQL query to get username (PostGraphile version)
export const GET_NAME_QUERY = gql`
  query GetName($id: String!) {
    identityByAccountId(accountId: $id) {
      accountId
      name
    }
  }
`;

// Fallback query for migrated addresses: check linkedIdentity via accounts table
export const GET_LINKED_IDENTITY_QUERY = gql`
  query GetLinkedIdentity($id: String!) {
    accounts(filter: { id: { equalTo: $id } }) {
      nodes {
        linkedIdentity {
          accountId
          name
        }
      }
    }
  }
`;

export interface Identity {
  accountId: string;
  name: string | null;
}

export interface GetNameResponse {
  identityByAccountId: Identity | null;
}

export interface GetLinkedIdentityResponse {
  accounts: {
    nodes: {
      linkedIdentity: Identity | null;
    }[];
  };
}

// Legacy type aliases for backward compatibility
export type AccountById = Identity;
export type AccountByPk = Identity;
